export default {
  'menu.welcome': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.login': 'ログイン',
  'menu.register': '登録',
  'menu.register-result': '登録結果',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.settings': 'アカウント設定',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
  'menu.充值': 'チャージ',
  'menu.充值.充值': 'チャージ',
  'menu.充值.查看': '表示',
  'menu.卡余额提醒': 'カード残高リマインダー',
  'menu.消纳': '処理',
  'menu.消纳.消纳': '処理',
  'menu.消纳.新建消纳': '新規処理',
  'menu.消纳.编辑': '編集',
  'menu.消纳.查看': '表示',
  'menu.统计分析': '統計分析',
  'menu.规则设置': 'ルール設定',
  'menu.系统设置': 'システム設定',
  'menu.系统设置.成员管理': 'メンバー管理',
  'menu.系统设置.成员列表': 'メンバーリスト',
  'menu.系统设置.添加成员': 'メンバー追加',
  'menu.系统设置.编辑成员': 'メンバー編集',
  'menu.系统设置.查看成员': 'メンバー表示',
  'menu.系统设置.角色与权限': 'ロールと権限',
  'menu.系统设置.角色列表': 'ロールリスト',
  'menu.系统设置.添加角色': 'ロール追加',
  'menu.系统设置.编辑角色': 'ロール編集',
  'menu.系统设置.查看角色': 'ロール表示',
  'menu.成员管理': 'メンバー管理',
  'menu.成员列表': 'メンバーリスト',
  'menu.添加成员': 'メンバー追加',
  'menu.编辑成员': 'メンバー編集',
  'menu.查看成员': 'メンバー表示',
  'menu.角色与权限': 'ロールと権限',
  'menu.角色列表': 'ロールリスト',
  'menu.添加角色': 'ロール追加',
  'menu.编辑角色': 'ロール編集',
  'menu.查看角色': 'ロール表示',
  'menu.基本信息': '基本情報',
  'menu.基本信息.服务片区': 'サービスエリア',
  'menu.基本信息.新建片区': '新規エリア',
  'menu.基本信息.编辑片区': 'エリア編集',
  'menu.基本信息.商户信息': '店舗情報',
  'menu.基本信息.新建商户': '新規店舗',
  'menu.基本信息.运营信息': '運営情報',
  'menu.服务片区': 'サービスエリア',
  'menu.新建片区': '新規エリア',
  'menu.商户信息': '店舗情報',
  'menu.新建商户': '新規店舗',
  'menu.运营信息': '運営情報',
  'menu.清运记录': '清運記録',
  'menu.到期提醒': '期限切れリマインダー',
  'menu.对账': '照合',
  'menu.对账.对账列表': '照合リスト',
  'menu.对账.手动对账': '手動照合',
  'menu.对账.查看': '表示',
  'menu.对账.新建手动对账': '新規手動照合',
  'menu.对账.去对账': '照合へ',
  'menu.对账列表': '照合リスト',
  'menu.手动对账': '手動照合',
  'menu.开票': '請求書',
  'menu.开票.开票列表': '請求書リスト',
  'menu.开票.手动开票': '手動請求書',
  'menu.开票.申请开票': '請求書申請',
  'menu.开票.查看开票': '請求書表示',
  'menu.开票.发起手动开票': '手動請求書発行',
  'menu.开票列表': '請求書リスト',
  'menu.手动开票': '手動請求書',
  'menu.回款': '支払い',
  'menu.回款.回款列表': '支払いリスト',
  'menu.回款.手动回款': '手動支払い',
  'menu.回款.完成回款': '支払い完了',
  'menu.回款.查看': '表示',
  'menu.回款.新建手动回款记录': '新規手動支払い記録',
  'menu.回款列表': '支払いリスト',
  'menu.手动回款': '手動支払い',
  'menu.现结回款': '即時支払い',
  'menu.消纳.消纳': '処理',
  'menu.消纳.新建消纳': '新規処理',
  'menu.消纳.编辑': '編集',
  'menu.消纳.查看': '表示',
  'menu.统计分析': '統計分析',
  'menu.规则设置': 'ルール設定',
  'menu.系统设置': 'システム設定',
  'menu.系统设置.成员管理': 'メンバー管理',
  'menu.系统设置.成员列表': 'メンバーリスト',
  'menu.系统设置.添加成员': 'メンバー追加',
  'menu.系统设置.编辑成员': 'メンバー編集',
  'menu.系统设置.查看成员': 'メンバー表示',
  'menu.系统设置.角色与权限': 'ロールと権限',
  'menu.系统设置.角色列表': 'ロールリスト',
  'menu.系统设置.添加角色': 'ロール追加',
  'menu.系统设置.编辑角色': 'ロール編集',
  'menu.系统设置.查看角色': 'ロール表示',
  'menu.成员管理': 'メンバー管理',
  'menu.成员列表': 'メンバーリスト',
  'menu.添加成员': 'メンバー追加',
  'menu.编辑成员': 'メンバー編集',
  'menu.查看成员': 'メンバー表示',
  'menu.角色与权限': 'ロールと権限',
  'menu.角色列表': 'ロールリスト',
  'menu.添加角色': 'ロール追加',
  'menu.编辑角色': 'ロール編集',
  'menu.查看角色': 'ロール表示',
  'menu.基本信息': '基本情報',
  'menu.基本信息.服务片区': 'サービスエリア',
  'menu.基本信息.新建片区': '新規エリア',
  'menu.基本信息.编辑片区': 'エリア編集',
  'menu.基本信息.商户信息': '店舗情報',
  'menu.基本信息.新建商户': '新規店舗',
  'menu.基本信息.编辑商户': '店舗編集',
  'menu.基本信息.查看商户': '店舗表示',
  'menu.基本信息.新增签订合同': '契約新規',
  'menu.基本信息.编辑合同': '契約編集',
  'menu.基本信息.查看合同': '契約表示',
  'menu.基本信息.新建人员': 'スタッフ新規',
  'menu.基本信息.编辑人员': 'スタッフ編集',
  'menu.基本信息.运营信息': '運営情報',
  'menu.服务片区': 'サービスエリア',
  'menu.新建片区': '新規エリア',
  'menu.商户信息': '店舗情報',
  'menu.新建商户': '新規店舗',
  'menu.编辑商户': '店舗編集',
  'menu.查看商户': '店舗表示',
  'menu.新增签订合同': '契約新規',
  'menu.编辑合同': '契約編集',
  'menu.查看合同': '契約表示',
  'menu.新建人员': 'スタッフ新規',
  'menu.编辑人员': 'スタッフ編集',
  'menu.运营信息': '運営情報',
  'menu.新建清运记录': '清運記録新規',
  'menu.编辑清运记录': '清運記録編集',
};
